export const SignatureLabels = {
    memberSignature: {
        en: "Member Signature",
        ta: "உறுப்பினரின் கையொப்பம்",
        te: "సభ్యుడి సంతకం",
        hi: "सदस्य के हस्ताक्षर",
        ml: "അംഗത്തിന്റെ ഒപ്പ്",
        kn: "ಸದಸ್ಯರ ಸಹಿ",
        mr: "सदस्याची सही",
        gu: "સભ્યના હસ્તાક્ષર",
    },
    spouseSignature: {
        en: "Spouse Signature",
        ta: "துணைவன் / துணைவியின் கையொப்பம்",
        te: "జీవిత భాగస్వామి సంతకం",
        hi: "जीवनसाथी के हस्ताक्षर",
        ml: "ഭാര്യ / ഭർത്താവിന്റെ ഒപ്പ്",
        kn: "ಪತಿ/ಪತ್ನಿಯ ಸಹಿ",
        mr: "पत्नीस / पतीची सही",
        gu: "પતિ / પત્નીના હસ્તાક્ષર",
    },
    guarantorSignature: {
        en: "Guarantor Signature",
        ta: "உத்தரவாததாரரின் கையொப்பம்",
        te: "గ్యారంటీదారు సంతకం",
        hi: "जमानतदार के हस्ताक्षर",
        ml: "ഉറപ്പുകാരന്റെ ഒപ്പ്",
        kn: "ಜಾಮೀನುಗಾರರ ಸಹಿ",
        mr: "जामिनदाराची सही",
        gu: "જામીનદારના હસ્તાક્ષર",
    },
    branchSealSignature: {
        en: "Branch Seal With Signature",
        ta: "கிளை முத்திரையுடன் கையொப்பம்",
        te: "శాఖ ముద్రతో సంతకం",
        hi: "शाखा मुहर के साथ हस्ताक्षर",
        ml: "ശാഖാ മുദ്രയോടുകൂടിയ ഒപ്പ്",
        kn: "ಶಾಖೆ ಮುದ್ರೆಯೊಂದಿಗೆ ಸಹಿ",
        mr: "शाखेच्या शिक्क्यासह सही",
        gu: "શાખાની સીલ સાથે હસ્તાક્ષર",
    },
    companySealSignature: {
        en: "Company Seal With Signature",
        ta: "நிறுவன முத்திரையுடன் கையொப்பம்",
        te: "కంపెనీ ముద్రతో సంతకం",
        hi: "कंपनी मुहर के साथ हस्ताक्षर",
        ml: "കമ്പനി മുദ്രയോടുകൂടിയ ഒപ്പ്",
        kn: "ಕಂಪನಿ ಮುದ್ರೆಯೊಂದಿಗೆ ಸಹಿ",
        mr: "कंपनीच्या शिक्क्यासह सही",
        gu: "કંપની સીલ સાથે હસ્તાક્ષર",
    },
};